import { render, staticRenderFns } from "./ProgramsListPage.vue?vue&type=template&id=42bea77c&"
import script from "./ProgramsListPage.vue?vue&type=script&lang=js&"
export * from "./ProgramsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports